// extracted by mini-css-extract-plugin
export default {"mainContainer":"ScopeOfEntrustmentTableArea_mainContainer__FldA9","topCaptionContainer":"ScopeOfEntrustmentTableArea_topCaptionContainer__dtzdF"};